<template>
  <el-dialog class="cmp-video-dialog" :title="title" :visible.sync="dialogVisible" @close="closePlay">
    <videoPlayer class="video-box" :video-url="videoUrl" :videoId="videoId" :state="!dialogVisible"></videoPlayer>
  </el-dialog>
</template>

<script>
  import videoPlayer from '@cmp/video-player'
  export default {
    components: { videoPlayer },
    data() {
      return {
        dialogVisible: false,
        videoId: '',
        videoUrl: '',
        title: ''
      }
    },
    methods: {
      init(url, id, title) {
        this.dialogVisible = true
        this.videoUrl = url
        this.videoId = id
        this.title = title
      },
      closePlay() {
        this.videoUrl = ''
        this.videoId = ''
        this.title = ''
        this.dialogVisible = false
      },
    }
  }
</script>

<style lang="scss" scoped>
.cmp-video-dialog {
  /deep/ .el-dialog {
    background: #000;
  }
}
// // 重置video样式
// .video-box {
//   /deep/ .video-js {
//     .vjs-big-play-button {
//       width: 50px;
//       height: 50px;
//       left: 50%;
//       top: 50%;
//       transform: translate(-50%, -50%);
//       border-radius: 100%;
//     }
//     .vjs-play-progress:before {
//       top: -5px;
//     }
//   }
// }
</style>